import React from "react";
import PropTypes from "prop-types";
import { Search } from "lucide-react";
import { NoData } from "../../../../Components/ui";

const HelpEmptyState = ({
  title = "No Matching Topics Found",
  description = "We couldn't find any questions or guides matching your search keyword. Try adjusting your query or resetting filters.",
  actionText = "Clear Search",
  onAction,
}) => {
  return (
    <NoData
      title={title}
      description={description}
      icon={<Search size={32} />}
      actionText={actionText}
      onAction={onAction}
      minHeight={300}
    />
  );
};

HelpEmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  actionText: PropTypes.string,
  onAction: PropTypes.func,
};

export default HelpEmptyState;
